import { api } from "./api";

export const proflieViewApi = (params) => {
    return api.get(`/profile/view`, { params: params });
};